// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const Sentry: any;

interface IUseSentry {
    captureException: (err: Error | any) => void;
    captureMessage: (msg: string) => void;
}

const isSentryRunning = () => typeof Sentry !== 'undefined';

export const useSentry = (): IUseSentry => {
    return {
        captureException: (err: Error | any) => {
            if (isSentryRunning() && Sentry.captureException) {
                Sentry.captureException(err);
            }
        },

        captureMessage: (msg: string) => {
            if (isSentryRunning() && Sentry.captureMessage) {
                Sentry.captureMessage(msg);
            }
        },
    };
};
